import React from 'react';
import CustomTable from '../../../../../../tables/CustomTable';
import { CustomColumn } from '../../../../../../../types/components/tables/tableTypes';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import { mainColors } from '../../../../../../../styling/theme';
import { addCommasToNumbersAndRound } from '../../../../../../../utilities/numberFormatters';
import type { EmirAssetLevelTableRow } from '../emirFundSummary.types';

interface AssetLevelTableProps {
  data: EmirAssetLevelTableRow[];
  exportFileName?: string;
}

const assetLevelTableColumns = (
  hasCounterparty: boolean,
): CustomColumn<EmirAssetLevelTableRow>[] => [
  {
    title: 'Date',
    field: 'date',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    title: 'Asset Name',
    field: 'assetName',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    title: 'Asset Type',
    field: 'assetType',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    title: 'ISIN',
    field: 'isin',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
  },
  {
    title: 'Counterparty',
    field: 'counterparty',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
    hidden: !hasCounterparty,
  },
  {
    title: 'Gross Exposure (EUR)',
    field: 'grossExposureEUR',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
    render: (rowData) => addCommasToNumbersAndRound(rowData.grossExposureEUR),
  },
  {
    title: 'EMIR Contribution (EUR)',
    field: 'emirContribution',
    cellStyle: { textAlign: 'center' },
    headerStyle: { textAlign: 'center' },
    render: (rowData) => addCommasToNumbersAndRound(rowData.emirContribution),
  },
];

const useStyles = makeStyles<Theme>(() => ({
  root: {
    border: `1px solid ${mainColors.lightGrey}`,
    borderRadius: '0.25rem',
    margin: '0.62rem',
  },
}));

const AssetLevelTable: React.FC<AssetLevelTableProps> = ({
  data,
  exportFileName,
}) => {
  const classes = useStyles();

  const hasCounterparty = data.some((row) => row.counterparty !== undefined);

  return (
    <div className={classes.root}>
      <CustomTable<EmirAssetLevelTableRow>
        columns={assetLevelTableColumns(hasCounterparty)}
        showToolbar
        data={data}
        title="Asset Level Data"
        exportFileName={exportFileName}
        options={{
          paging: false,
          search: false,
          exportButton: true,
        }}
        pdfDontMoveToNewPage={true}
      />
    </div>
  );
};

export default AssetLevelTable;
